// AlternaSleepProgressTracker.jsx

import React from "react";
import "./AlternaSleepProgressTracker.scss";

const AlternaSleepProgressTracker = ({ steps, currentStep }) => {
  return (
    <div className="alterna-sleep-progress-tracker">
      <div className="progress-container">
        {/* Progress lines - each step has its own segment */}
        <div className="progress-lines">
          {steps.map((label, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;
            
            // Each step gets a line segment that represents that section
            const percentPerStep = 100 / steps.length;
            
            return (
              <div
                key={index}
                className={`progress-segment ${
                  isCompleted ? "completed" : isActive ? "active" : "inactive"
                }`}
                style={{
                  left: `${index * percentPerStep}%`,
                  width: `calc(${percentPerStep}% - 20px)` // Gap of 20px between segments
                }}
              ></div>
            );
          })}
        </div>

        {/* Steps - circle and label in same line */}
        <div className="steps-wrapper">
          {steps.map((label, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;
            
            // Calculate same positioning as progress segments
            const percentPerStep = 100 / steps.length;

            return (
              <div 
                key={index} 
                className="step-item"
                style={{
                  left: `${index * percentPerStep}%`
                }}
              >
                {/* Circle and text in same horizontal line */}
                <div className="step-content">
                  <div
                    className={`step-circle ${
                      isCompleted ? "completed" : isActive ? "active" : "inactive"
                    }`}
                  >
                    {isCompleted && (
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.6667 3.5L5.25004 9.91667L2.33337 7"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    {isActive && !isCompleted && (
                      <div className="inner-dot"></div>
                    )}
                  </div>

                  <div
                    className={`step-label ${
                      isCompleted ? "label-completed" : isActive ? "label-active" : "label-inactive"
                    }`}
                  >
                    {label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AlternaSleepProgressTracker;
